<template>
  <div class="app-sticky-cart" @click="scrollToCart()" aria-hidden="true">
    <div class="sticky-cart--left">
      <div class="cart-icon">
        <img src="files/flash/images/svg-icons/cart.svg" alt="">
      </div>
      <div class="down-icon">
        <img src="files/flash/images/svg-icons/arrowd-yellow.svg" alt="">
      </div>
    </div>
    <div class="sticky-cart--right">
      <div class="price" :class="{'promo': hasPricePromotion}">
        <strong v-if="hasPricePromotion" class="price--strikethrough">{{price(fakeNormalPriceForBirthdayPromo)}}</strong>
        <strong v-if="showPriceStarts" class="price--label">&nbsp;ab</strong>
        <div class="price--amount" >&nbsp;{{priceWithoutEuro(promoBenefits.promoPrice.promoAmount)}}</div>
        <strong class="price--label">&nbsp;&euro; mtl.</strong>
      </div>
      <div class="stairway" v-if="hasLimitedPricePromotion">
      <span v-for="(stairway, index) in promoBenefits.additionalPriceStairways" :key="stairway.duration">
        <span v-if="index > 0">, </span>
        <dyn-slot :slotData="stairway"><slot name="dynLimitedPrice">Ab dem XX. Monat</slot></dyn-slot>
        <span v-if="showPriceStarts">&nbsp;ab</span>
        <span>&nbsp;{{price(stairway.promoAmount)}}</span>
      </span>
      </div>
    </div>
  </div>
</template>
<script>

import price from '@/mixins/formatters/price'
import useFeature from '@/mixins/useFeature'

export default {
  name: 'StickyCart',
  mixins: [
    price,
    useFeature('birthdayPromo')
  ],
  props: {
    promoBenefits: {
      type: Object,
      default: null
    },
    showPriceStarts: {
      type: Boolean,
      default: true
    },
    process: {
      type: String,
      default: 'ordering'
    }
  },
  computed: {
    hasPricePromotion: function () {
      return this.fakeNormalPriceForBirthdayPromo !== this.promoBenefits.promoPrice.promoAmount // this.promoBenefits.price.amount
    },
    selectedAboOptionIdForFakeBirthdayPromo: function () {
      return this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds']?.length > 0 ? this.$store.getters['checkoutv2/' + this.process + '/_cart/selectedTariffOptionIds'][0] : []
    },
    fakeNormalPriceForBirthdayPromo () {
      if (this.birthdayPromo && this.selectedAboOptionIdForFakeBirthdayPromo === '3036138') {
        return this.promoBenefits.price.amount + 500
      }
      return this.promoBenefits.price.amount
    },
    hasLimitedPricePromotion: function () {
      return this.promoBenefits.promoPrice.duration > 0
    }
  },
  methods: {
    scrollToCart () {
      const targetElement = document.getElementById('cart-sidebar')
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' })
      }
    }
  }
}
</script>
